import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                      from '../api/api.service';
import { ReactivateSubscriptionComponent } from './subscription.reactivate.component';
import { SessionService }                  from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  constructor (
    private apiService    : ApiService,
    private modalService  : NgbModal,
    private sessionService: SessionService
  ) {}

  reactivate ( session : any ) : Promise<boolean> {
    return this.apiService.get('/company/get_chargify_subscription_for_past_due', session.company_settings.id, undefined, { withCredentials: true })
    .then(( balanceInCents : number ) => {
      const modal = this.modalService.open(ReactivateSubscriptionComponent);

      modal.componentInstance.balanceInCents = balanceInCents;
      modal.componentInstance.session        = session;

      return modal.result;
    })
    .catch(() => {
      this.sessionService.clear();

      return Promise.reject(false);
    });
  }
}
